import Dashboard from "../../dashboard/Dashboard";
import Button from "../../../components/buttons/Button";
import "../../../components/generalComponents.scss";
import style from "../../reviews/review.module.scss";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getDetails, updateData } from "../../../services/review.service";
import { GetLanguageRequest } from "../types";
import { useEffect, useState } from "react";
import { ActionType } from "../../../utils/constants";
import formatDate from "../../../utils/date.formater";
import showToast from "../../../utils/show.toast";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function LanguageToSpeakeDetail() {
  const [languageSpoken, setLanguageSpokenDetail] =
    useState<GetLanguageRequest | null>({
      id: 0,
      merchantTeacherEmail: "",
      merchantFirstName: "",
      requestedAt: "",
      merchantId: 0,
    });

  const navigate = useNavigate();
  const { requestId } = useParams();
  const query = useQuery();
  const status = query.get("status");

  const [loading, setLoading] = useState(false);

  const fetchDetails = async () => {
    try {
      const endpoint = `teachers/${requestId}/language-update`;
      const response = await getDetails(endpoint);

      console.log(response.result);

      if (response.status === "success") {
        setLanguageSpokenDetail(response.result);
      } else {
        showToast(response.message || "Failed to fetch languages", false);
      }
    } catch (err: any) {
      const message = err?.message || "An error occurred";
      showToast(message, false);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (action: ActionType) => {
    const endpoint = `teachers/${requestId}/language-update`;
    await updateData(endpoint, {
      reqid: Number(requestId),
      action,
    });
    showToast(`Merchant ${action.toLocaleLowerCase()} successfully.`, true);
    return navigate(`/review/language-spoken/list?status=${status}`);
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  return (
    <Dashboard>
      {loading && <p className={style.textStyle}>Loading Requests.....</p>}

      <>
        <div style={{ display: "flex" }}>
          <FontAwesomeIcon
            icon={faArrowLeftLong}
            onClick={() => navigate(-1)}
            style={{
              marginTop: "1px",
              marginRight: "0.7rem",
              cursor: "pointer",
            }}
          />
          <h5>Language Spoken Details</h5>
        </div>
        <div className="section">
          <div className={style.textWrapper}>
            <h5>First name</h5>
            <p className={style.textStyle}>
              {languageSpoken?.merchantFirstName}
            </p>
          </div>

          <div className={style.textWrapper}>
            <h5> User email</h5>
            <p className={style.textStyle}>
              {languageSpoken?.merchantTeacherEmail}
            </p>
          </div>

          <div className={style.textWrapper}>
            <h5>Requested Date</h5>
            <p className={style.textStyle}>
              {formatDate((languageSpoken?.requestedAt as any) ?? null)}
            </p>
          </div>

          <div className={style.textWraperRowStyle}>
            <div className={style.textWrapper}>
              <div className={style.textWrapper}>
                <h5>Language</h5>
                <p className={style.textStyle}>
                  {languageSpoken?.language?.map((item) => item.language)}
                </p>
              </div>
            </div>

            <div className={style.textWrapper}>
              <h5>Proficiency Level</h5>
              <p className={style.textStyle}>
                {languageSpoken?.language?.map((item) => item.proficiency)}
              </p>
            </div>
          </div>

          <hr
            style={{
              marginTop: "1rem",
              marginBottom: "2rem",
              fontWeight: "lighter",
            }}
          />
          <div className="dashboard-button">
            <Button
              name="Approve"
              type="activate-button"
              onClick={() => handleStatusUpdate(ActionType.ACCEPTED)}
            />
            <Button
              name="Reject"
              onClick={() => handleStatusUpdate(ActionType.REJECT)}
              type="delete-button"
            />
          </div>
        </div>
      </>
    </Dashboard>
  );
}
